module.exports = __webpack_public_path__ + "static/img/mobileBackground.a5cceb9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobileBackground.gif
// module id = zThJ
// module chunks = 0